import { render, staticRenderFns } from "./e-person.vue?vue&type=template&id=5d9766a4&"
import script from "./e-person.vue?vue&type=script&lang=js&"
export * from "./e-person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports